import React from 'react';
import {Box} from '@mui/material';

export function NorafTabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`noraf-tabpanel-${index}`}
      aria-labelledby={`noraf-tab-${index}`}
      {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
